import { getSceneDetail } from '@/api/scene'
import copyScene from '@/components/CopyScene'
export default {
  SceneCopy({ commit }, params) {
    getSceneDetail({ id: params.rowId }).then(response => {
      var title = '跨行业复制场景功能用例'
      var dialog = params.viewController.$dialog({
        template: h => {
          const scene = response?.data?.content
          return (
            <sky-copy-scene
              scene={scene}
              onCb={function() {
                dialog.remove()
                params.viewController.fetch()
              }}
            />
          )
        },
        components: {
          copyScene
        },
        props: {
          title: title,
          width: '65%',
          showDefaultFooter: false,
          closeOnPressEscape: false
        }
      })
    })
  }
}
